import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	lng: "pt",
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
	interpolation: {
		escapeValue: false // React already does escaping
	},
	// Garantir que as traduções estejam sempre disponíveis
	keySeparator: '.',
	load: 'languageOnly',
	preload: ['pt'],
	// Configuração para evitar erros de chaves ausentes
	missingKeyHandler: (lng, ns, key, fallbackValue) => {
		console.warn(`Missing translation key: ${lng}.${ns}.${key}`);
		return key.split('.').pop(); // Retorna a última parte da chave como fallback
	}
});

export { i18n };
